import "../styles/ControlBtnsContainer.scss";

function ControlBtnsContainer({ children }: any) {
    return <div className="control-btns-container">{children}</div>;
}

export default ControlBtnsContainer;
